import { render, staticRenderFns } from "./a23.vue?vue&type=template&id=8f1ccada&scoped=true"
import script from "./a23.vue?vue&type=script&lang=js"
export * from "./a23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1ccada",
  null
  
)

export default component.exports